<template>
  <div>
    <v-btn
        v-if="userType === 'students' && tab == 0 && mode === 'advanced'"
        class="mr-2"
            color="success"
            @click="openRouteSelectionDialog(-1,1)"
            :disabled="isLoading || selected_student_ids.length===0"
        >
            <v-icon class="me-2">mdi-location-enter</v-icon>
            <span>{{ $t('users.table.setPickup') }}</span>
    </v-btn>
    <v-btn
        v-if="userType === 'students' && tab == 0 && mode === 'advanced'"
        class="mr-2"
            color="success"
            @click="openRouteSelectionDialog(-1,0)"
            :disabled="isLoading || selected_student_ids.length===0"
        >
            <v-icon class="me-2">mdi-location-exit</v-icon>
            <span>{{ $t('users.table.setDropoff') }}</span>
    </v-btn>
    <v-data-table
        v-model="selected_students"
        item-key="id"
        :loading="isLoading"
        :loading-text="$t('users.table.loadingText')"
        :headers="getHeader()"
        :items="users"
        :show-select="userType === 'students' && tab<2"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('common.search')"
            class="mx-4"
          ></v-text-field>
        </template>

        <template v-slot:item.status_id="{ item }">
          <v-chip
            :color="getStatusColor(item.status_id)"
            dark
          >
            {{ getStatusValue(item.status_id) }}
          </v-chip>
        </template>

        <template v-slot:item.name="{ item }">
            {{item.name}}
            <v-tooltip v-if="item.expired != null && item.expired"  bottom color="info">
                <template v-slot:activator="{ on }">
                <v-icon color="error" v-on="on">
                    mdi-cancel
                </v-icon>
                </template>
                <span>{{ $t('users.table.documentExpiredTooltip') }}</span>
            </v-tooltip>
        </template>
        <template v-if="userType === 'guardians'" v-slot:item.role_id="{ item }">
                    <v-chip
                        dark
                        :color="item.role_id === 4? 'primary' : 'info'"
                    >
                        {{ item.role_id === 4? $t('users.table.role.parent') : $t('users.table.role.guardian') }}
                    </v-chip>
        </template>
        <template v-if="userType === 'drivers'" v-slot:item.bus="{ item }">
          <v-chip
            dark
            @click="$emit('assignBus', item)"
            :color="getBusAssignmentColor(item.bus)"
          >
            {{ item.bus != null? item.bus.license : $t('users.table.noBus') }}
          </v-chip>
        </template>

        <template v-slot:item.created_at="{ item }">
          <small>{{ item.created_at | moment("LL") }}</small> -
          <small class="text-muted">{{ item.created_at | moment("LT") }}</small>
        </template>
        <template v-slot:item.student_settings.morning_bus="{ item }">
          <v-tooltip v-if="tab<2 && userType === 'students' && mode === 'simple'" bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-chip
                    dark
                    @click="$emit('set-student-bus', item, 1)"
                    :color="getBusAssignmentColor(item.student_settings.morning_bus)"
                >
                    {{ item.student_settings.morning_bus != null? item.student_settings.morning_bus.license : $t('users.table.noBus') }}
                </v-chip>
            </template>
            <span>{{ $t('users.table.assignMorningBusTooltip') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.student_details.pickup_stop="{ item }">
          <v-tooltip v-if="tab==0 && userType === 'students' && mode === 'advanced'" bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-card v-if="item.student_details == null || item.student_details.pickup_stop == null" v-bind="attrs" v-on="on" class="ma-2" outlined color="error" @click="openRouteSelectionDialog(item.id, 1)">
                    <v-list density="compact" disabled>
                        <v-list-item>
                            <v-list-item-content><small>{{ $t('users.table.noAssignment') }}</small></v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
                <v-card v-else v-bind="attrs" v-on="on" class="ma-2" outlined color="success" @click="openRouteSelectionDialog(item.id, 1)">
                    <!-- @click="$emit('set-student-bus', item, 0)" -->
                    <v-list density="compact" disabled>
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>mdi-road-variant</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content><small>{{ item.student_details.pickup_route.name }}</small></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>mdi-map-marker</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content><small>{{ item.student_details.pickup_stop.name }}</small></v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="item.student_details.pickup_pick_time">
                            <v-list-item-icon>
                                <v-icon small>mdi-bus-clock</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <small>{{ tConvert(item.student_details.pickup_pick_time) }}</small>
                                </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </template>
            <span>{{ $t('users.table.assignAfternoonTooltip') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.student_details.drop_off_stop="{ item }">
          <v-tooltip v-if="tab==0 && userType === 'students' && mode === 'advanced'" bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-card v-if="item.student_details == null || item.student_details.drop_off_stop == null" v-bind="attrs" v-on="on" class="ma-2" color="error" outlined @click="openRouteSelectionDialog(item.id, 0)">
                    <v-list density="compact" disabled>
                        <v-list-item>
                            <v-list-item-content><small>{{ $t('users.table.noAssignment') }}</small></v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
                <v-card v-else v-bind="attrs" v-on="on" class="ma-2" outlined color="success" @click="openRouteSelectionDialog(item.id, 0)">
                    <v-list density="compact" disabled>
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>mdi-road-variant</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content><small>{{ item.student_details.drop_off_route.name }}</small></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>mdi-map-marker</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content><small>{{ item.student_details.drop_off_stop.name }}</small></v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="item.student_details.drop_off_drop_time">
                            <v-list-item-icon>
                                <v-icon small>mdi-bus-clock</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <small>{{ tConvert(item.student_details.drop_off_drop_time) }}</small>
                                </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </template>
            <span>{{ $t('users.table.assignAfternoonBusTooltip') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.student_settings.afternoon_bus="{ item }">
          <v-tooltip v-if="tab<2 && userType === 'students' && mode === 'simple'" bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-chip
                    dark
                    @click="$emit('set-student-bus', item, 0)"
                    :color="getBusAssignmentColor(item.student_settings.afternoon_bus)"
                >
                    {{ item.student_settings.afternoon_bus != null? item.student_settings.afternoon_bus.license : $t('users.table.noBus') }}
                </v-chip>
            </template>
            <span>{{ $t('users.table.assignAfternoonBusTooltip') }}</span>
          </v-tooltip>
        </template>


        <template v-slot:item.actions="{ item }">
          <v-tooltip v-if="tab==2" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                class="mr-2 primary"
                @click="$emit('view-user', item)"
              >
                <v-icon small class="mr-2">
                  mdi-card-account-mail-outline
                </v-icon>
                {{ $t('users.table.selectAction') }}
              </v-btn>
            </template>
            <span>{{ $t('users.table.approveRejectTooltip') }}</span>
          </v-tooltip>
          <v-tooltip v-else bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('view-user', item)">
                mdi-eye
              </v-icon>
            </template>
            <span>{{ $t('common.view') }}</span>
          </v-tooltip>
          <v-tooltip v-if="tab==0" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="checkIfLocationEnabled(item) && mode === 'simple'" v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('show-student-location', item)">
                mdi-map-marker
              </v-icon>
            </template>
            <span>{{ $t('users.table.locationTooltip') }}</span>
          </v-tooltip>
          <v-tooltip v-if="tab<2"  bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('edit-user', item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>{{ $t('common.edit') }}</span>
          </v-tooltip>
          <v-tooltip v-if="tab<2" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('suspend-user', item, users.indexOf(item))">
               {{item.status_id==3? icons.mdiAccountCheck: icons.mdiAccountOff}}
              </v-icon>
            </template>
            <span>{{item.status_id==3? $t('users.table.activateAction') : $t('users.table.suspendAction') }}</span>
          </v-tooltip>
          <v-tooltip v-if="tab!=2" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="userType === 'drivers' && item.bus" v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('unassign-bus', item)">
                mdi-fridge-industrial-off
              </v-icon>
              <v-icon v-else-if="userType === 'drivers'" v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('assign-bus', item)">
                mdi-bus
              </v-icon>
            </template>
            <span>{{item.bus? $t('users.table.removeBusTooltip') : $t('users.table.assignBusTooltip') }}</span>
          </v-tooltip>
          <v-tooltip v-if="tab!=2" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="userType === 'schools'" v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('login-as-school', item)">
                mdi-login
              </v-icon>
            </template>
            <span>{{ $t('users.table.loginToSchoolTooltip') }}</span>
          </v-tooltip>
          <v-tooltip v-if="tab!=2" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="userType === 'schools'" v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('delete-school', item)">
                mdi-delete
              </v-icon>
            </template>
            <span>{{ $t('users.table.deleteSchoolTooltip') }}</span>
          </v-tooltip>
          <v-tooltip v-if="tab!=2" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="canDeleteUser(item)" v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('delete-user', item, userType)">
                mdi-delete
              </v-icon>
            </template>
            <span>{{ isParentRow(item) ? $t('users.deleteParent') : $t('users.deleteStudent') }}</span>
          </v-tooltip>

        </template>
    </v-data-table>
    <RouteSelectionDialog @selection-confirmed="onRouteSelectionConfirmed" @selection-cancelled="onRouteSelectionCancelled" :display_dialog="route_dialog"
    :pick_up="selected_pick_up"
    :student_id="selected_student_id" :student_ids="selected_student_ids"></RouteSelectionDialog>
  </div>
</template>

<script>
import {
  mdiAccountCheck,
  mdiAccountOff,
} from "@mdi/js";
//import route-selection-dialog
import RouteSelectionDialog from "@/views/users/route-selection-dialog.vue";

export default {
  props: {
    users: Array,
    userType: String,
    tab: Number,
    mode: String,
  },
  components: {
    RouteSelectionDialog
  },
  data() {
    return {
      isLoading: false,
      selected_student_ids: [], // This will store just the IDs
      selected_students: [],
      search: "",
      icons: {
        mdiAccountCheck,
        mdiAccountOff,
      },
      route_dialog: false,
      selected_student_id: null,
      selected_pick_up: null
    };
  },
  computed: {
    defaultsHeaders() {
      return [
        { text: "ID", value: "id", align: "start", filterable: false },
        { text: this.$t("common.name"), value: "name" },
        { text: this.$t("common.email"), value: "email" },
        { text: this.$t("common.status"), value: "status_id" },
        { text: this.$t("users.table.headers.createdAt"), value: "created_at" },
        { text: this.$t("common.actions"), value: "actions", sortable: false },
      ];
    },
    driverHeaders() {
      return [
        { text: "ID", value: "id", align: "start", filterable: false },
        { text: this.$t("common.name"), value: "name" },
        { text: this.$t("common.email"), value: "email" },
        { text: this.$t("users.table.headers.bus"), value: "bus" },
        { text: this.$t("common.status"), value: "status_id" },
        { text: this.$t("users.table.headers.createdAt"), value: "created_at" },
        { text: this.$t("common.actions"), value: "actions", sortable: false },
      ];
    },
    studentAdvancedHeaders() {
      return [
        { text: "ID", value: "student_identification", align: "start", filterable: false },
        { text: this.$t("common.name"), value: "name" },
        { text: this.$t("users.table.headers.parentName"), value: "parent.name" },
        //pickup stop
        { text: this.$t("users.table.headers.pickupStop"), value: "student_details.pickup_stop" , align: "start", filterable: false, sortable: false},
        //drop off stop
        { text: this.$t("users.table.headers.dropoffStop"), value: "student_details.drop_off_stop", align: "start", filterable: false, sortable: false },
        { text: this.$t("common.status"), value: "status_id" },
        { text: this.$t("users.table.headers.createdAt"), value: "created_at" },
        { text: this.$t("common.actions"), value: "actions", sortable: false },
      ];
    },
    studentSimpleHeaders() {
      return [
        { text: "ID", value: "student_identification", align: "start", filterable: false },
        { text: this.$t("common.name"), value: "name" },
        { text: this.$t("users.table.headers.parentName"), value: "parent.name" },
        { text: this.$t("users.table.headers.parentEmail"), value: "parent.email" },
        //morning bus
        { text: this.$t("users.table.headers.morningBus"), value: "student_settings.morning_bus" },
        //afternoon bus
        { text: this.$t("users.table.headers.afternoonBus"), value: "student_settings.afternoon_bus" },
        { text: this.$t("common.status"), value: "status_id" },
        { text: this.$t("users.table.headers.createdAt"), value: "created_at" },
        { text: this.$t("common.actions"), value: "actions", sortable: false },
      ];
    },
    parentHeaders() {
      return [
        { text: "ID", value: "id", align: "start", filterable: false },
        { text: this.$t("common.name"), value: "name" },
        { text: this.$t("common.email"), value: "email" },
        { text: this.$t("users.table.headers.role"), value: "role_id" },
        { text: this.$t("common.status"), value: "status_id" },
        { text: this.$t("users.table.headers.createdAt"), value: "created_at" },
        { text: this.$t("common.actions"), value: "actions", sortable: false },
      ];
    },
    statuses() {
      return [
        { value: this.$t("users.table.statuses.active"), color: "success" },
        { value: this.$t("users.table.statuses.pending"), color: "warning" },
        { value: this.$t("users.table.statuses.suspended"), color: "error" },
        { value: this.$t("users.table.statuses.underReview"), color: "error" },
        { value: this.$t("users.table.statuses.insufficientBalance"), color: "error" },
      ];
    },
  },
  watch: {
    selected_students(newSelection) {
      // Update the selected_student_ids array whenever the selection changes
      this.selected_student_ids = newSelection.map(student => student.id);
    }
  },
  methods: {
      //the guardians page lists parents (role 4) and guardians (role 5); only a parent can be deleted here
      isParentRow(item) {
          return item && item.role_id === 4
      },
      canDeleteUser(item) {
          if (this.userType === 'students') return true
          if (this.userType === 'guardians') return this.isParentRow(item)
          return false
      },
    openRouteSelectionDialog(student_id, pick_up) {
      this.route_dialog = true;
      this.selected_student_id = student_id;
      this.selected_pick_up = pick_up;
    },
    onRouteSelectionConfirmed(data) {
      this.route_dialog = false;
      console.log(data);
      //emit
      this.$emit('route-selected', {
        studentId: data.studentId,
        studentIds: data.studentIds,
        routeId: data.routeId,
        stopId: data.stopId,
        pickup: data.pickup,
        tripId: data.tripId
      });
    },
    onRouteSelectionCancelled() {
      this.route_dialog = false;
    },
    getStatusColor(status)
    {
      return this.statuses[status-1].color;
    },
    getStatusValue(status)
    {
      return this.statuses[status-1].value;
    },
    getBusAssignmentColor(bus)
    {
        return bus != null? 'info': 'error';
    },
    getStopDetails(item, pickup)
    {
        if(pickup)
        {
            return item.student_settings.pickup_route_stop.route.name + '\n' + item.student_settings.pickup_route_stop.stop.name;
        }
        return item.student_settings.dropOffRouteStop;
    },
    tConvert(time) {
      if (time == null) {
        return null;
      }
      // Check correct time format and split into components
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)/) || [time];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(""); // return adjusted time or original string
    },
    getHeader()
    {
      if(this.userType === 'drivers') return this.driverHeaders;
      if(this.userType === 'students')
      {
            if(this.mode === 'simple'){
                return this.studentSimpleHeaders;
            }else{
                return this.studentAdvancedHeaders;
            }
      }
      if(this.userType === 'guardians') return this.parentHeaders;
      return this.defaultsHeaders;
    },
    checkIfLocationEnabled(item)
    {
        return this.userType === 'students' && item.student_settings != null && (item.student_settings.pickup_lat != null && item.student_settings.pickup_lng != null || item.student_settings.drop_off_lat != null && item.student_settings.drop_off_lng != null);
    }
  },
};
</script>
<style lang="scss">
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover{
  cursor: pointer;
  background: rgba($primary-shade--light, 0.15) !important;
}
</style>
